import {Button} from '@material-ui/core';
import {useState} from 'react';
import AthenaAPI from '../../../APIs/AthenaAPI';
import CRM from '../../../APIs/CRM';
import RootStore from '../../../Core/mobx/RootStore';
import constants from '../../../constants';
import {ParameterStore} from '../../../Core/mobx/ParameterStore/ParameterStore';

const {CUSTOMER_PORTAL_URL} = constants;

interface CalcfocusConsentButtonProps {
    parameterStore: ParameterStore;
    onConsentSend: () => void;
}
export const CalcfocusConsentButton: React.FC<CalcfocusConsentButtonProps> = ({
    parameterStore,
    onConsentSend = () => {},
}) => {
    const {approval} = parameterStore;
    const email = approval.emailAddress.value;

    type fieldName =
        | 'firstName'
        | 'lastName'
        | 'dob'
        | 'socialSecurityNumber'
        | 'addressZipCode'
        | 'gender'
        | 'byear'
        | 'phoneNumber'
        | 'emailAddress';

    const [validationDetails, _] = useState([
        {n: 'firstName', v: 'Lucy'},
        {n: 'lastName', v: 'Williams'},
        {n: 'gender', v: 'female'},
        {n: 'dob', v: '1948-04-08'},
        {n: 'socialSecurityNumber', v: '222222222'},
        {n: 'addressZipCode', v: '11787'},
    ]);
    const getParam = (detailName: fieldName): any => {
        if (approval == null) {
            return validationDetails.find((detail: any) => detail.n == detailName)?.v;
        } else {
            if (detailName == 'dob') {
                return approval.byear.value + '-' + approval.bmonth.value + '-' + approval.bday.value;
            } else {
                return approval[detailName].value;
            }
        }
    };
    const SendEmail = async () => {
        const getConsentCodeData = {
            firstName: getParam('firstName'),
            lastName: getParam('lastName'),
            dob: getParam('dob'),
        };

        const respCode = await CRM.GetCustomerConsentCode(
            getConsentCodeData.firstName,
            getConsentCodeData.lastName,
            getConsentCodeData.dob,
        );

        const code = respCode?.code;
        if (!code) {
            RootStore.uiStore.showSnackbar('Error during forming customer consent link', 'error');
            return;
        }

        const link = `${CUSTOMER_PORTAL_URL}/consent-form/?c=${code}`;

        try {
            if (!email) {
                throw new Error('No email address found');
            }

            await AthenaAPI.sendCalcfocusConsentEmail({userEmail: email, link: link});

            RootStore.uiStore.showSnackbar('Consent email has been sent', 'success');
            onConsentSend();
        } catch (error) {
            RootStore.uiStore.showSnackbar('There was an issue sending consent email', 'error');
        }
    };

    return (
        <Button id="calcfocusConsentButton" variant="contained" color="primary" onClick={SendEmail}>
            Send consent link
        </Button>
    );
};
